// extracted by mini-css-extract-plugin
export default {"List_bg_image":"Demo_List_bg_image__pvLly","data_container":"Demo_data_container__CjPCJ","links":"Demo_links__KO2QZ"};